export default "__VITE_ASSET__fBTlIIT9__"